import { Paper } from '@mui/material';
import './contentscontainer.css'
import Home from './pages/home';
import Tools from './pages/tools';
import { Route, Routes ,Navigate} from 'react-router-dom';
import About from './pages/about';
import Contact from './pages/contact';
import EarthquakeMoniEntrance from './pages/earthquakemoni'
import PostalStamps from './pages/postalstamps';
import MapWorks from './pages/mapworks';
import QSLGallery from './pages/qslgallery';
import ArticleTitles from './pages/ArticleTitles';
import ArticleContent from './pages/articles/ArticleContent';
import LBNR from './pages/articles/LBNR';
import TIBP from './pages/articles/TIBP';
import Calculator from './pages/tools/calculator';
import { useState,useEffect } from 'react';
import LossCalculator from './pages/tools/losscalculator';

function ContentsContainer(){

    const [titleData, setTitleData] = useState([])
    const [loading,setLoading] = useState(false)

    useEffect(() => {
        getTitleData()
    },[]);

    const getTitleData = async () => {
        setLoading(true); // 开始加载
        try {
            const formData = new URLSearchParams();

            const res = await fetch('https://api.sadatsunemyspace.uk/api/fetchallarctitles', {
                method: 'POST',
                headers: { "Content-Type": "application/x-www-form-urlencoded" },
                body: formData.toString()
            });
            const { data } = await res.json();
            setTitleData(data);
        } catch (error) {
            console.error("Error fetching title data:", error);
        } finally {
            setLoading(false); // 加载完成
        }
    };

    return(
        <div className='takemuchspace'>
            <Paper className="contentpaper" elevation={5}>
                <Routes>
                    <Route path='/home' element={<Home/>}></Route>
                    <Route path='/tools' element={<Tools/>}></Route>
                    <Route path='/about' element={<About/>}></Route>
                    <Route path='/qslgallery' element={<QSLGallery/>}></Route>
                    <Route path='/contact' element={<Contact/>}></Route>
                    <Route path='/earthmoni' element={<EarthquakeMoniEntrance/>}></Route>
                    <Route path='/stamps' element={<PostalStamps/>}></Route>
                    <Route path='/mapworks' element={<MapWorks/>}></Route>
                    <Route path='/tools/postage-calculator' element={<Calculator/>}></Route>
                    <Route path='/tools/remit-loss-calculator' element={<LossCalculator/>}></Route>
                    <Route path='/' element={<Navigate to='/home'/>}></Route>
                    <Route path='/others' element={<ArticleTitles categoryName={'Others'} categoryID={'oth'}/>}></Route>
                    <Route path='/gis-tech-skills' element={<ArticleTitles categoryName={'GIS Tech & Skills'} categoryID={'gis'}/>}></Route>
                    <Route path='/radiohobbyist' element={<ArticleTitles categoryName={'Articles about My Hobby'} categoryID={'rh'}/>}></Route>
                    <Route path='/others/tibet-pictures' element={<TIBP/>}></Route>
                    <Route path='/mapworks/lanzhou-beef-noodles-restraurants' element={<LBNR/>}></Route>
                    {!loading && titleData.map((item) => (
                    <Route key={item.id} path={item.link} element={<ArticleContent articleID={item.id}/>}/>
                ))}
                </Routes>
            </Paper>
        </div>
    );
    
}

export default ContentsContainer;